/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_CutoffInputs */



/**
* | output |
* | --- |
* | "Cutoff (Top 5)" |
*
* @param {Og_Cfg_CutoffInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_cutoff = /** @type {((inputs?: Og_Cfg_CutoffInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_CutoffInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Coupure (Top 5)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Corte (Top 5)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Corte (Top 5)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Taglio (Top 5)")
	return /** @type {LocalizedString} */ ("Cutoff (Top 5)")
});